import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import {} from "@angular/common";

@Component({
  selector: "app-loader-fullscreen",
  templateUrl: "./loader-fullscreen.component.html",
  styleUrls: ["./loader-fullscreen.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class LoaderFullscreenComponent {
  blue = input<boolean>();
}
